import React, { ComponentType } from 'react'
import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { userRegistrationIdState } from '../../State/user.Atom';
import config from '../../config';
import { toast } from 'react-toastify';

interface IProps extends RouteProps {
    component: ComponentType<RouteComponentProps<any>> | ComponentType<any>;
}

export const AdvisoryRoutes = ({ component: Component, ...rest }: IProps) => {
    const userRegistrationId = useRecoilValue(userRegistrationIdState);
    return (
        <Route
            {...rest} render={props => {
                if (!userRegistrationId) {
                    return <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
                }
                if (userRegistrationId.toLocaleLowerCase() !== config.advisory_registration_id.toLocaleLowerCase()) {
                    toast.error("You are not authorized to access this page");
                    return <Redirect to={{ pathname: "/home" }} />
                }
                return <Component {...props} />
            }
            }
        />
    );
}

